import { NgOptimizedImage } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ShowdownDirective } from '../../../directives/animations/showdown.directive';
import { ProductCategory } from '../../../models/product';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import { ProductApiService } from '../../../services/apis/product-api.service';

@Component({
  selector: 'section[app-home-categories]',
  imports: [FileurlPipe, NgOptimizedImage, ShowdownDirective, RouterModule, MatIconModule],
  templateUrl: './home-categories.html',
  styleUrl: './home-categories.scss',
})
export class HomeCategories implements OnInit {

  constructor(private productApi: ProductApiService) { }

  ngOnInit(): void {
    this.findProductCategories();
  }

  loading: boolean = false;
  categories: ProductCategory[] = [];
  async findProductCategories() {
    try {
      this.loading = true;
      const r = await this.productApi.findProductCategories();
      this.categories = r || [];
    } catch (error) {

    } finally {
      this.loading = false;
    }
  }

}
